<ng-template #autoRenewalFailedAlert>
  <span class="mr-1">{{ 'shared:licenses.autoRenewalFailed' | i18next }}</span>
  {{ 'shared:licenses.checkYour' | i18next }}
  <mbs-payment-method-button></mbs-payment-method-button>
  or
  <mbs-button
    type="primary"
    [isCtrl]="true"
    [size]="size.inherit"
    (click)="openRenewModal()"
    >{{ 'shared:licenses.tryRenewAgain' | i18next }}</mbs-button
  >
</ng-template>
